import { DorkGenerationOptions, GeneratedDork } from "@/types/dork";
import { supabase } from "@/integrations/supabase/client";

const FUNCTION_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-dorks`;

export async function generateDorks(options: DorkGenerationOptions): Promise<{ dorks: GeneratedDork[]; inputType: string }> {
  // Get the current session token for authentication
  const { data: { session } } = await supabase.auth.getSession();
  
  if (!session?.access_token) {
    throw new Error("Authentication required. Please sign in to generate dorks.");
  }

  const response = await fetch(FUNCTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(options),
  });

  if (!response.ok) {
    const error = await response.json();
    if (response.status === 401) {
      throw new Error("Authentication required. Please sign in to continue.");
    }
    if (response.status === 429) {
      throw new Error(error.error || "Rate limit exceeded. Please wait a moment and try again.");
    }
    if (response.status === 402) {
      throw new Error("Service temporarily unavailable.");
    }
    throw new Error(error.error || "Failed to generate dorks");
  }

  const data = await response.json();
  return { dorks: data.dorks, inputType: data.inputType || "keyword" };
}
